module.exports = __webpack_public_path__ + "static/media/home-jumbotron-bg.142d80e8.png";